import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class SDWanAssets extends Component {
  constructor(props) {
    super(props);
    const colors = ["#219DBB", "#EE476F"];

    this.state = {
      series: [
        {
          name: "Sum of Record",
          data: [2, 2],
        },
      ],
      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "SDWAN Controller",
            "Tenants",
            "Directors",
            "SDWAN Hubs",
            "uCPES",
            "vCPEs",
          ],
          title: {
            text: "Status", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        yaxis: {
          title: {
            // text: "Assets", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
          // Use logarithmic scale
          logarithmic: true,
          min: 1, // Start from 1 since log scale does not support 0
          tickAmount: 5, // Control the number of ticks on the Y-axis
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 500,
          },
          background: {
            enabled: true,
            foreColor: "#656161",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#656161",
          },
          offsetY: -20,
        },
        legend: {
          show: false,
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "80%",
            distributed: true,
            borderRadius: 0,
            dataLabels: {
              position: "top",
            },
          },
        },
      },
    };
  }
  render() {
    return (
      <div>
        {this.props.message === "Data found" ? (
          <Chart
            options={this.state.options}
            series={this.state.series}
            type="bar"
            height={200}
          />
        ) : (
          <div
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#605E5C",
            }}
          >
            {this.props.message}
          </div>
        )}
      </div>
    );
  }
}
